export default __webpack_public_path__ + "static/media/auditai2.9cee2f90.png";